import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-tooltip-content"]

import {SvgIcon} from '../svg.ts';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionRunStatus',
  props: {
    status: {},
    size: { default: 16 },
    className: { default: '' },
    localeStatus: { default: undefined }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.status)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        "data-tooltip-content": _ctx.localeStatus ?? _ctx.status
      }, [
        (_ctx.status === 'success')
          ? (_openBlock(), _createBlock(_unref(SvgIcon), {
              key: 0,
              name: "octicon-check-circle-fill",
              class: "text green",
              size: _ctx.size,
              "class-name": _ctx.className
            }, null, 8 /* PROPS */, ["size", "class-name"]))
          : (_ctx.status === 'skipped')
            ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                key: 1,
                name: "octicon-skip",
                class: "text grey",
                size: _ctx.size,
                "class-name": _ctx.className
              }, null, 8 /* PROPS */, ["size", "class-name"]))
            : (_ctx.status === 'cancelled')
              ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                  key: 2,
                  name: "octicon-stop",
                  class: "text yellow",
                  size: _ctx.size,
                  "class-name": _ctx.className
                }, null, 8 /* PROPS */, ["size", "class-name"]))
              : (_ctx.status === 'waiting')
                ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                    key: 3,
                    name: "octicon-clock",
                    class: "text yellow",
                    size: _ctx.size,
                    "class-name": _ctx.className
                  }, null, 8 /* PROPS */, ["size", "class-name"]))
                : (_ctx.status === 'blocked')
                  ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                      key: 4,
                      name: "octicon-blocked",
                      class: "text yellow",
                      size: _ctx.size,
                      "class-name": _ctx.className
                    }, null, 8 /* PROPS */, ["size", "class-name"]))
                  : (_ctx.status === 'running')
                    ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                        key: 5,
                        name: "octicon-meter",
                        class: "text yellow",
                        size: _ctx.size,
                        "class-name": 'job-status-rotate ' + _ctx.className
                      }, null, 8 /* PROPS */, ["size", "class-name"]))
                    : (_openBlock(), _createBlock(_unref(SvgIcon), {
                        key: 6,
                        name: "octicon-x-circle-fill",
                        class: "text red",
                        size: _ctx.size
                      }, null, 8 /* PROPS */, ["size"])),
        _createCommentVNode(" failure, unknown ")
      ], 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}
}

})